module.exports = __webpack_public_path__ + "img/star.c0210b84.svg";